import {Component, Input, OnInit} from '@angular/core';
import {TourService} from '../services/tour.service';

@Component({
  selector: 'gt-stars',
  template: `
    <div class="rating-stars orange">{{ ratingText }}</div>
  `,
  styles: [`
    .rating-stars {
      font-family: FontAwesome, sans-serif;
      font-size: 3rem;
      line-height: 4rem;
      letter-spacing: 5px;
      padding-left: 10px;
      vertical-align: middle;
    }
  `]
})
export class StarsComponent implements OnInit {

  @Input() ratingScore: number;
  ratingText: string;
  constructor(private tourService: TourService) { }

  ngOnInit() {
    this.ratingText = this.tourService.getStarsStringForRating(this.ratingScore);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/stars.component.ts